import { Icon,  Upload } from "antd";
import React  from "react";

export const  PPTableUpload  = (item , icon , uploadIcon , deleteIcon , handleDocumentUpdate , list) => {
    const data ={
        document_option : item?.document_option || "",
        document_id : item?.document_id,
        company_associate_id : list?.company_associate_id || "",
        associate_key : list?.associate_key || 1,

        document_master_id: item?.documents.length && item?.documents[0].id,
        company_document_id : item?.documents.length && item?.documents[0].company_document_id,
    };
    return(
        <React.Fragment>
            {icon}
            {item && !item.documents.length ? <Upload
                action={null}
                accept={".pdf,.jpg,.jpeg,.png,.webp,application/pdf,images/jpeg,images/png,images/jpg"}
                className="file-uploader-icon" 
                beforeUpload={(file) => {   handleDocumentUpdate("upload",file , data);   return false;}}
                showUploadList={false}
            >
                <Icon type={uploadIcon} style={{fontSize : 16  , color : "#27AE60" ,  paddingRight: "20px", cursor : "pointer"}} />
            </Upload> : 
                <Icon type={deleteIcon} style={{fontSize : 16  , color : "red" , cursor : "pointer"}} onClick={() => handleDocumentUpdate("delete" , {} , data)}/>}
        </React.Fragment>
    );
};